import PropTypes from 'prop-types';

import { Navigate, useLocation } from 'react-router-dom';
import { getCookie } from '../utils';
import MinimalLayout from '../layout/minimalLayout';
import NotFound from '../pages/notFound';
import Login from '../pages/login';

const VerificaSeEstaLogado = ({ children }) => {
    const logado = getCookie("authToken");
    const location = useLocation();

    if (logado && location.pathname === '') return <Navigate to={'/'} />;

    return children;
};

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/login',
            element: (
                <VerificaSeEstaLogado>
                    <Login />
                </VerificaSeEstaLogado>
            ),
        },
        {
            path: '/*',
            element: <NotFound />,
        },
    ],
};

VerificaSeEstaLogado.propTypes = {
    children: PropTypes.node,
};

export default AuthenticationRoutes;
